/// <amd-module name="ArtifactPolicy/Templates/PolicyDefinition" />
import { IArtifactPolicyTemplateContribution, IContributionWithId } from "ArtifactPolicy/Templates/Types";
import { IObservableValue } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { format } from "VSS/Core/Util/String";

export function getObservableKey(contributionId: string, inputId: string): string {
    return contributionId + "-" + inputId;
}

export function constructPolicyDefinition(pageContext: IVssPageContext, contributionIds: string[], inputsObservableDictionary: { [key: string]: IObservableValue<string> }): string {
    if (contributionIds.length === 1 && contributionIds[0] === basicPolicyTemplatecontributionId) {
        return policyDefinitionBasicTemplate;
    }

    const contributionsWithIds = contributionIds.map(cid => {
        return {
            id: cid,
            contribution: pageContext.getService<IVssContributionService>("IVssContributionService").getContribution(cid)!
        } as IContributionWithId;
    });

    const policyDefinitionContents = contributionsWithIds.map(contributionWithId => replaceInputsInTemplate(contributionWithId.id, contributionWithId.contribution, inputsObservableDictionary));
    const violationFunctions = contributionsWithIds.map(contributionWithId => contributionWithId.contribution.violationsFunction);
    const violationFunctionsString = violationFunctions.filter(f => !!f).join("|");
    const initialString = format(policyDefinitionPreReqFormat, violationFunctionsString);
    return initialString + policyDefinitionContents.filter(pdc => !!pdc).join("\r\n\r\n");
}

function replaceInputsInTemplate(contributionId: string, templateContribution: IArtifactPolicyTemplateContribution, inputsObservableDictionary: { [key: string]: IObservableValue<string> }): string {
    const relevantInputKeys = (templateContribution.inputs || []).map(input => { return { input: input, inputKey: getObservableKey(contributionId, input.id) }; });

    let content = "" + templateContribution.regoTemplate;
    relevantInputKeys.forEach(key => {
        let inputValue = inputsObservableDictionary[key.inputKey] ? inputsObservableDictionary[key.inputKey].value : "";
        if (key.input.array) {
            const valueParts = inputValue.split(",").map(val => {
                let quotedVal = val.replace(/^[\s]+"?|"?[\s]+$/g, "")
                    .replace("\"", "\\\"");
                quotedVal = "\"" + quotedVal + "\"";

                return quotedVal;
            });

            inputValue = valueParts.join(",");
        }

        content = content.replace(`$(${key.input.id})`, inputValue);
    });

    return content;
}

const policyDefinitionPreReqFormat = "package test \r\n\r\nimport input as values default \r\n\r\nviolations = \"unable to evaluate policies\"\r\nviolations = msg {{ \r\n       msg := {0} \r\n}} \r\n\r\nfetchImageName(uri) = img {{  \r\n       out := regex.find_n(\"/.*@\", uri, 1) \r\n       img := trim(out[0], \"/@\")\r\n}}\r\n\r\n ";

const policyDefinitionBasicTemplate = "package test \r\n\r\nimport input as values default \r\n\r\nviolations = msg { \r\n       msg := \"\" \r\n}";

export const basicPolicyTemplatecontributionId = "ms.vss-pipelinechecks.policy-template-basic";
